export default "__VITE_ASSET__raAY4z0r__"